import type { ShareableRouteContext } from '@client/types/router';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { parseRegisterRouteId } from './parse-register-route-id';

export const Route = createFileRoute('/console/$orgId/compliance/registers/$registerId')({
    params: {
        parse({ registerId }) {
            return { registerId: parseRegisterRouteId(registerId) };
        },
    },
    beforeLoad({ context: { trpcUtils }, params: { registerId } }): ShareableRouteContext {
        // The register name is the page title (one 20px title per page, with the
        // section icon chip) — not just a breadcrumb crumb. Resolved lazily like
        // the crumb rather than awaited here: an async beforeLoad would make the
        // router own the loading and error states, and the page deliberately
        // renders its own Skeleton and InlineQueryError-with-retry instead.
        async function title() {
            const register = await trpcUtils.register.getRegister.ensureData({ id: registerId });
            return register.name;
        }

        return {
            ui: { title },
            breadcrumb: { title },
        };
    },
    component: Outlet,
});
